import { IWXWindow, IWXDocument, IGoToComponent } from '../types'
import { noop } from 'lodash-es'

declare let window: IWXWindow
declare let document: IWXDocument
const { WeixinJSBridge } = window

function onBridgeReady({ config, callBack }: { config: any; callBack: IGoToComponent }): void {
  // eslint-disable-next-line
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    config,
    function(res: any) {
    const { err_msg: resString } = res
    switch (resString) {
      case 'get_brand_wcpay_request:ok':
        return callBack({ component: 'Result', type: 'success' })
      case 'get_brand_wcpay_request:cancel':
        return callBack({ component: 'Result', type: 'question' })
      case 'get_brand_wcpay_request:fail':
        return callBack({ component: 'Result', type: 'question' })
      default:
        return noop
    }
  })
}

export function wxJsApiPay(params: any) {
  if (typeof WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
    }
  } else {
    onBridgeReady(params)
  }
}
